/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import applicationFormStyle from "../applicationFormStyle";

const powerOfAttorneyStyle = {
  ...applicationFormStyle,
  outcome: {
    textAlign: "center",
    border: "1px solid",
    borderColor: "primary.main",
    borderRadius: "5px",
    padding: "0.5rem",
  },
  text: {
    textAlign: "left",
  },
  poaHeadline: {
    color: "primary.main",
    fontWeight: 500,
    textAlign: "center",
  },
  imageCircleContainer: {
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto",
    width: "100px",
    height: "100px",
    padding: "36px",
    borderRadius: "50% !important",
    "& > img": {
      maxHeight: "100px",
    },
  },
  imgCircleContainer: {
    paddingTop: "1rem",
  },
};

export default powerOfAttorneyStyle;
